import React from 'react';
import './container.scss';
export var Container = function (_a) {
    var children = _a.children, extendClass = _a.extendClass, fullWidth = _a.fullWidth, ctabar = _a.ctabar;
    var containerClasses = 'c-container';
    if (extendClass)
        containerClasses += " ".concat(extendClass);
    if (ctabar) {
        containerClasses += ' c-container--ctabar';
    }
    if (fullWidth) {
        containerClasses += ' c-container--fullwidth';
    }
    return React.createElement("div", { className: containerClasses }, children);
};
